(function () {
  'use strict';

  function initTruncatedBio(root) {
    if (root.dataset.arcanaBioWired === 'true') return;
    root.dataset.arcanaBioWired = 'true';
    const toggle = root.querySelector('.arcana-truncated-bio__toggle');
    const expand = root.querySelector('.arcana-truncated-bio__expand');
    if (!toggle || !expand) return;

    const readMore = root.dataset.readMore || 'Read more';
    const readLess = root.dataset.readLess || 'Read less';

    toggle.addEventListener('click', () => {
      const isExpanded = root.classList.toggle('is-expanded');
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      expand.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
      toggle.textContent = isExpanded ? readLess : readMore;
    });
  }

  function initAll() {
    document.querySelectorAll('.arcana-truncated-bio').forEach(initTruncatedBio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
